import { http } from '@/network/http'
import { addGA, errorGA, initGA, inlineStyle, deleteCookie } from '@/utils'
import api from '@/api'
import { Toast } from 'vant'
import { REDIRECT_URL, RESPONSE_TYPE } from '@/utils/gop'
import session from '@/utils/session'

interface Params {
  profile: object
  apkLink: string
  feedbackQuestions: Array<object>
  imageUpload: boolean
  ios_download_enabled: 0 | 1 | undefined
  ios_download_url: string
}

interface ConfigData {
  is_ind: number
  region: string
  register_time: number[]
  playtest_time: number[]
  css: string
  transify: any
  has_activation_code: number
}

interface ConfigResponse {
  data: ConfigData
}

const mockData = {
  is_ind: 0,
  region: 'en',
  register_time: [1722852111, 2741399444],
  playtest_time: [1722934197, 2741399444],
  css:
    '/* header */\n.header-logo {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/logo.png");\n}\n.home-banner {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/bg_main.png");\n}\n/* icon */\n.fb-black_icon {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/fb_black_icon.png");\n}\n.google-black_icon {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/google_black_icon.png");\n}\n.fb-icon {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/fb_icon.png");\n}\n.google-icon {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/google_icon.png");\n}\n.android-icon {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/android_icon.png");\n}\n.profile-icon {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/profile_icon.png");\n}\n.diamond-icon-1 {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/diamond1.png");\n}\n.diamond-icon-2 {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/diamond2.png");\n}\n.diamond-icon-3 {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/diamond3.png");\n}\n.diamond-icon-4 {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/diamond4.png");\n}\n.bug-icon {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/bug_icon.png");\n}\n.user-icon {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/user_icon.png");\n}\n.email-icon {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/email_icon.png");\n}\n.phone-icon {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/phone_icon.png");\n}\n.icon-check {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/ico_check.png");\n}\n.icon-uncheck {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/ico_close.png");\n}\n.van-radio__icon--round i {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/radio_check.png");\n}\n.van-radio__icon--checked .van-icon {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/radio_checked.png");\n}\n\n.van-checkbox__icon--square i {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/checkbox_check.png");\n}\n\n.van-checkbox__icon--checked .van-icon {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/checkbox_checked.png");\n}\n.userinfo-icon {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/user_icon.png");\n}\n.emailinfo-icon {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/email_icon.png");\n}\n.phoneinfo-icon {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/phone_icon.png");\n}\n.table-arrow {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/arrow.png");\n}\n.main-arrow {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/main_arrow.png");\n}\n.func-role-1 {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/role_1.png");\n}\n.download-arrow {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/download_arrow.png");\n}\n/* page */\n.page {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/bg.png");\n}\n\n/* tips */\n.tips-icon {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/warn_icon.png");\n}\n\n/* copy-icon */\n.copy-icon1 {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/copy_icon1.png");\n}\n.copy-icon2 {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/copy_icon2.png");\n}\n.dialog-close_icon {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/dialog_close_icon.png");\n}\n\n/* bg */\n.bug-hunter_bg {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/bug_hunter_bg.png");\n}\n\n\n.disappoint_bg {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/disappoint.png");\n}\n\n.app-error-bg.mobile {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/error_bg_portrait.jpg");\n}\n.app-error-bg.pc {\n  background-image: url("https://cdn.wildflamestudio.com/common/web_event/freefire_advance/images/error_bg_landscape_new.jpg");\n}',
  transify: {
    TOAST_ERROR_CODE: 'Unknown error, error code {code}',
    TOAST_EVENTOVER: 'Event ended',
    TOAST_EVENT_CLOSED_AWHILE: 'The event is closed temporarily. Please check again later.',
    TOAST_EVENT_END: 'Event ended',
    TOAST_EVENT_NOTOPEN: "Event hasn't started",
    TOAST_EXCHANGE_SUCCESS: 'Successfully Redeemed',
    TOAST_GEM_NOT_ENOUGH: 'Insufficient diamonds, please top up and come back again',
    TOAST_LOGIN_FAILED: 'Login failed',
    TOAST_NETWORK_BUSY: 'Server busy, please try again later',
    TOAST_NETWORK_ERROR: 'Network connection error, please try again later',
    TOAST_OPERATE_BUSY: 'Too many requests, please try again later',
    TOAST_PAY_FAILED: 'Purchase failed',
    TOAST_PURCHASE_SUCCESS: 'Purchase Successful',
    TOAST_SERVER_BUSY: 'Server busy, please try again later',
    TOAST_SERVER_NOTWORK: 'Service unavailable',
    TOAST_SERVER_TIMEOUT: 'Service timeout',
    TOAST_WRONG_REGION: 'This event is not available for your region',
    'ADV-ACTIVATIONCODE-PASS': 'Congratulations',
    'ADV-ACTIVATIONCODE-PASSHINT':
      'Your application is passed. Your activation code will be shown below. Please use this activiation code to login the game.',
    'ADV-ACTIVATIONCODE-UNDERREVIEW': 'Thanks for registration',
    'ADV-ACTIVATIONCODE-UNDERREVIEWHINT': 'Your application on pending. Please wait for our response.',
    ADV_APK_COPY: 'COPY DOWNLOADLINK',
    ADV_APK_HINT: 'Copied successfully, paste in your browser to download',
    ADV_BENEFIT_SUBTITLE_1: 'What is Free Fire Advance Server',
    ADV_BENEFIT_SUBTITLE_1_CONTEXT:
      'Free Fire Advance Server is a program where players can try newest features that is not released yet in Free Fire!',
    ADV_BENEFIT_SUBTITLE_2: 'Bug Hunting and Feedback',
    ADV_BENEFIT_SUBTITLE_2_CONTEXT:
      'Players will help on finding and reporting bug in Free Fire Advance Server and give input about new features',
    ADV_BENEFIT_SUBTITLE_3: 'Rules',
    ADV_BENEFIT_SUBTITLE_3_CONTEXT:
      'Use activation code to log in to Advance Server. A limited number of codes available. Regist now and receive your code.',
    ADV_BENEFIT_TITLE_1: 'Free Fire Advance Server',
    ADV_BUGHISTORY_CHECK: 'Check',
    ADV_BUGHISTORY_SUBTITLE: 'List of Submitted Bug',
    ADV_BUGHISTORY_TITLE: 'Bug History',
    ADV_BUG_DETAILS_SUBTITLE: 'Your submitted bug details',
    ADV_BUG_DETAILS_TITLE: 'Bug Details',
    ADV_BUG_PROOF_SUBTITLE: 'Image or video links you have uploaded',
    ADV_BUG_PROOF_TITLE: 'Bug Proof Upload',
    ADV_BUTTON_HINT: 'Click to copy the link and paste in your browser to download',
    ADV_COPY_SUCESS: 'copied successfully',
    ADV_DEFAULT: 'default',
    ADV_DOWNLOAD_ANDROID: 'For Android Only',
    ADV_DOWNLOAD_IOS: 'ADV_DOWNLOAD_IOS',
    ADV_DOWNLOAD_IOS_HINT: 'ADV_DOWNLOAD_IOS_HINT',
    ADV_DOWNLOAD_IOS_TEXT: 'ADV_DOWNLOAD_IOS_TEXT',
    ADV_DOWNLOAD_APK_TEXT: 'Download Apk',
    ADV_DOWNLOAD_DIAMOND_1: 'Find Bug',
    ADV_DOWNLOAD_DIAMOND_2: 'Get Diamond',
    ADV_DOWNLOAD_FAQ_A1: 'A: No, your live Free Fire server will not be deleted if you enter Advance Server',
    ADV_DOWNLOAD_FAQ_A2:
      'A: Use activation code to log in to Advance Server. A limited number of codes are available. Regist now and receive your code.',
    ADV_DOWNLOAD_FAQ_A3:
      'A: Because Advance Server can only hold a certain number of users, if you did not receive the activation code, please wait for our response.',
    ADV_DOWNLOAD_FAQ_A4: 'A: Download start on February 8',
    ADV_DOWNLOAD_FAQ_A5: 'A: You can start playing from February 8',
    ADV_DOWNLOAD_FAQ_A6: 'A: The server will close on February 20',
    ADV_DOWNLOAD_FAQ_A7:
      'A: Your Advance Server will be deleted after the period ends. However, you can still play on our Official Server.',
    ADV_DOWNLOAD_FAQ_Q1: 'Q: Will my Free Fire account be deleted if I enter this server?',
    ADV_DOWNLOAD_FAQ_Q2: 'Q: Will every registered user get access to Free Fire Advanced Server?',
    ADV_DOWNLOAD_FAQ_Q3: "Q: I have installed Advanced Server APK, why can't I login?",
    ADV_DOWNLOAD_FAQ_Q4: 'Q: When can I download the APK?',
    ADV_DOWNLOAD_FAQ_Q5: 'Q: When can I start playing?',
    ADV_DOWNLOAD_FAQ_Q6: 'Q: When will the server close?',
    ADV_DOWNLOAD_FAQ_Q7: 'Q: Will my Free Fire Advance Server account be deleted after period ends?',
    ADV_DOWNLOAD_FAQ_TITLE: 'FAQ',
    ADV_DOWNLOAD_HINT_1: 'Download start on {day} {month} {year}',
    ADV_DOWNLOAD_HINT_2: 'adv client version',
    ADV_DOWNLOAD_REPORTBUG_HINT: '',
    ADV_DOWNLOAD_SUBTITLE_1: 'APK Client',
    ADV_DOWNLOAD_SUBTITLE_2: 'Download now and play in advance server!',
    ADV_DOWNLOAD_TITLE: 'Download',
    ADV_FEEDBACK_BUGHINT: 'Pls fill in the time',
    ADV_FEEDBACK_COSTUME: 'Costume',
    ADV_FEEDBACK_DESCRIPTION_NEED: 'Pls fill in bug description',
    ADV_FEEDBACK_IMAGE: 'The image is too large to upload.',
    ADV_FEEDBACK_IMAGE_VIDEO_NEED: 'Pls upload bug image or video',
    ADV_FEEDBACK_LINK_FORMAT: 'Pls fill correct link',
    ADV_FEEDBACK_PHONE_NEED: 'Pls enter phone model',
    ADV_FEEDBACK_SUBMITHINT: 'incomplete',
    ADV_FEEDBACK_SUCCESS: 'Submission successful',
    ADV_FEEDBACK_UID_CONTEXT: 'Please enter your advence server UID',
    ADV_FEEDBACK_UID_HINT: 'Invalid UID',
    ADV_FEEDBACK_UID_TITLE: 'Advance server UID',
    ADV_FF_ACCOUNT_NOT_FOUND: 'Free Fire game account not found',
    ADV_FINISH: 'Finish',
    ADV_GENERATING: 'The activation code will be ready shortly!',
    ADV_HOMEPAGE_BOTTOM: 'Login now using your Facebook account to play in Free Fire Advance Server',
    ADV_HOMEPAGE_BOTTOM_TITLE: 'Interested?',
    ADV_HOMEPAGE_GAME_TITLE: 'Free Fire',
    ADV_HOMEPAGE_SUB_TITLE: 'Advance Server Registration',
    ADV_HOMEPAGE_TITLE_1: 'Free Fire Advance Server Registration',
    ADV_HOMEPAGE_TITLE_3: 'Login using your Facebook account to sign-up for Free Fire Advance Server',
    ADV_IOS_HINT_NONE: 'ADV_IOS_HINT_NONE',
    ADV_LIMIT_TIP: 'The Free Fire Advance Server is not available for this region.',
    ADV_LIMIT_TITLE: 'Sorry!',
    ADV_LOGIN: 'Login Facebook',
    ADV_LOGIN_GOOGLE: 'Login Google',
    ADV_MENU_BUG: 'Bug Report',
    ADV_MENU_DOWNLOAD: 'Download APK',
    ADV_MENU_HISTORY: 'Bug History',
    ADV_MENU_LOGOUT: 'Log Out',
    ADV_MENU_PROFILE: 'Your Profile',
    ADV_MENU_RETURN: 'Homepage',
    ADV_MENU_REWARDS: 'Rewards',
    ADV_NEXT: 'Next',
    ADV_OTHERS: 'others',
    ADV_PHONE_MODEL_TEXT: 'Phone Model',
    ADV_POFILE_SUBTITLE: 'Your registered profile on Free Fire Advance Server',
    ADV_POFILE_TITLE: 'Your Profile',
    ADV_PROFILE_OK: 'OK',
    ADV_REGISTRATION_BOTTOM: 'Please make sure your email and phone number is active',
    ADV_REGISTRATION_ERROR_TOAST_EMAIL: 'Please enter correct E-mail',
    ADV_REGISTRATION_ERROR_TOAST_NAME: 'Please enter correct name',
    ADV_REGISTRATION_ERROR_TOAST_PHONE: 'Please enter correct phone number',
    ADV_REGISTRATION_INFO_1: 'Full Name',
    ADV_REGISTRATION_INFO_2: 'Active E-mail',
    ADV_REGISTRATION_INFO_3: 'Active Phone Number',
    ADV_REGISTRATION_INFO_4: 'ADV_REGISTRATION_INFO_4',
    ADV_REGISTRATION_JOIN: 'Join Now!',
    ADV_REGISTRATION_JOIN_HINT: 'Please complete the registration information first',
    ADV_REGISTRATION_SUBTITLE: 'Fill your profile',
    ADV_REGISTRATION_SUCCESS: 'Registration successful',
    ADV_REGISTRATION_TITLE: 'Profile',
    ADV_REPORTBUG_LASTQUESTION: 'Describe bugs you met',
    ADV_REPORTBUG_OPTIONS_DESC: '',
    ADV_REPORTBUG_OPTIONS_TITLE: '',
    ADV_REPORTBUG_QUESTION: '',
    ADV_REPORTBUG_SUBTITLE: 'Describe your problem in advance server',
    ADV_REPORTBUG_TEXTAREA_TIP: 'Bug Description',
    ADV_REPORTBUG_TEXT_2_TEXTAREA: 'Describe the costume you wearing when met the bug',
    ADV_REPORTBUG_TIMECHOOSE: 'When did you met the bug?',
    ADV_REPORTBUG_TITLE: 'Bug Reporting',
    ADV_REPORT_BUG_TEXT: 'Bug Report',
    ADV_REPORT_UPLOAD_IMAGE_1: 'Image 1',
    ADV_REPORT_UPLOAD_IMAGE_2: 'Image 2',
    ADV_REPORT_UPLOAD_IMAGE_3: 'Image 3',
    ADV_REPORT_UPLOAD_TEXT: 'Upload bug image or video link here:',
    ADV_REPORT_UPLOAD_VIDEO: 'Video Link',
    ADV_REWARDS_CONTRIBUTOR_1: 'Main Contributor (1person)',
    ADV_REWARDS_CONTRIBUTOR_2: 'Main Contributor (2people)',
    ADV_REWARDS_CONTRIBUTOR_3: 'Main Contributor (3people)',
    ADV_REWARDS_CONTRIBUTOR_4: 'Main Contributor',
    ADV_REWARDS_DIAMOND_1: '3000 Diamonds',
    ADV_REWARDS_DIAMOND_2: '2000 Diamonds',
    ADV_REWARDS_DIAMOND_3: '1000 Diamonds',
    ADV_REWARDS_DIAMOND_4: '100 Diamonds',
    ADV_REWARDS_GRANDPRIZE_TITLE1: 'Grand Prize',
    ADV_REWARDS_GRANDPRIZE_TITLE2: 'Based on their contributions.',
    ADV_REWARDS_HUNTER_TITLE1: 'Bug Hunter Rewards',
    ADV_REWARDS_HUNTER_TITLE2: 'First unknown bug hunter',
    ADV_REWARDS_TITlE: 'Rewards',
    ADV_TIMELINE: 'Timeline',
    ADV_TIMELINE_ADV_OPEN: 'Advanced Server Opened',
    ADV_TIMELINE_ADV_OPEN_TIME: '2/8',
    ADV_TIMELINE_FIRSTBATCH: 'Server open',
    ADV_TIMELINE_FIRSTBATCH_TIME: '2/8',
    ADV_TIMELINE_SECONDBATCH: 'Server close',
    ADV_TIMELINE_SECONDBATCH_TIME: '2/20',
    ADV_TIMELINE_TITLE_1: 'Server opening time',
    ADV_TOAST01: 'The activation code is currently out of stock, please come back later!',
    ADV_UPLOAD: 'upload',
    ADV_VIDEOLINK_TIP01: 'Tip 1: We recommend to upload the video onto YouTube, and provide a YouTube link here',
    ADV_VIDEOLINK_TIP02:
      'Tip 2: If you can only upload the video via Google Drive, please open the access to all visitors',
    ADV_YOUR_PROFILE_TEXT: 'Your Profile',
    ADV_REGISTRATION_INFO_4_ANDROID: 'ANDROID',
    ADV_REGISTRATION_INFO_4_IOS: 'IOS',
  },
  has_activation_code: 0,
}

// const mockDelay = (delay: number = 2000) => {
//   return new Promise((resolve) => {
//     console.log('延时开始')
//     setTimeout(() => {
//       console.log('延时结束')
//       resolve(11)
//     }, delay)
//   })
// }
const isDev = process.env['NODE_ENV'] == 'development'
const getMockData = (): Promise<ConfigResponse> => Promise.resolve({ data: mockData })

const getInfoData = (lang: string): Promise<ConfigResponse> => {
  if (isDev) {
    return getMockData()
  }

  return http.get(`${api.config}?lang=${lang}`) as Promise<ConfigResponse>
}

let stateStorage
if (sessionStorage.getItem('store')) {
  stateStorage = JSON.parse(sessionStorage.getItem('store') || '')
} else {
  stateStorage = {}
}
const state = {
  // ⬇️⬇️⬇️⬇️⬇️
  accessToken: '', // 在一开始获取token同时隐藏url  只用于取代链接参数
  code: '',
  // ⬆️⬆️⬆️⬆️⬆️
  css: stateStorage.css || '',
  config: stateStorage.config || null,
  // isLogin: true,
  // isRegister: true,
  isLogin: stateStorage.isLogin || false, // login status
  isRegister: stateStorage.isRegister || false, // register status
  profile: stateStorage.profile || null,
  userEmail: stateStorage.userEmail || '',
  lang: stateStorage.lang || null,
  region: stateStorage.region || 'en',
  activationCode: stateStorage.activationCode || '',
  feedbackHistory: stateStorage.feedbackHistory || null,
  nationCode: stateStorage.nationCode || '',
  playtestStartTime: stateStorage.playtestStartTime || 0,
  downloadOpen: stateStorage.downloadOpen || false,
  feedbackOpen: stateStorage.feedbackOpen || false,
  registerOpen: stateStorage.registerOpen || false,
  apkLink: stateStorage.apkLink || '',
  iosLink: stateStorage.iosLink || '',
  questions: stateStorage.questions || null,
  imageUpload: stateStorage.imageUpload || false,
  gameLogin: stateStorage.gameLogin || true, // adv game login
  loginFrom: stateStorage.loginFrom || 'external',
  iosDownloadEnabled: typeof stateStorage.iosDownloadEnabled === 'number' ? stateStorage.iosDownloadEnabled : undefined,
  transify: stateStorage.transify || {
    TOAST_NETWORK_BUSY: 'Server busy, please try again later',
    TOAST_LOGIN_FAILED: 'Login failed',
    ADV_LIMIT_TIP: 'Kamu tidak memiliki ijin untuk bermain di Free Fire Advance Ser',
    ADV_LIMIT_TITLE: 'Sorry!',
  },
  has_activation_code: 1, // 1为设置告警，已经用完，其他情况为0
  indexInit: false,

  // 默认不是ind区
  region_ind: 0,
  account_ind: 0,
  is_ind: 0,
}

const judgeTime = (start: any, end: any) => {
  const now = Date.parse(new Date().toString()) / 1000
  if (now < end && now >= start) {
    return true
  } else {
    return false
  }
}
const handleError = (error: any, delay?: number, hideClose?: boolean) => {
  errorGA(error)

  let err: string | undefined
  const transify = ''

  if (transify) {
    if (typeof error === 'string') {
      err = transify[error]
    } else if (error.message) {
      err = transify[error.message]
    }
  }
}

const checkArray = (target: any) => Array.isArray(target)

const mutations = {
  setValue(state: any, data: any) {
    state[data.key] = data.value
  },
}

const actions = {
  getConfig({ commit }: any, lang: string) {
    commit('setValue', {
      key: 'lang',
      value: lang,
    })
    return (
      getInfoData(lang)
        // http
        //   .get(`${api.config}?lang=${lang}`)
        .then((res: ConfigResponse) => {
          const resData = res.data
          commit('setValue', {
            key: 'region_ind',
            value: resData.is_ind,
          })

          commit('setValue', {
            key: 'region',
            value: resData.region,
          })
          commit('setValue', {
            key: 'transify',
            value: resData.transify,
          })
          // 是否存在注册激活码
          commit('setValue', {
            key: 'has_activation_code',
            value: resData.has_activation_code,
          })
          if (resData.playtest_time && checkArray(resData.playtest_time)) {
            commit('setValue', {
              key: 'downloadOpen',
              value: judgeTime(resData.playtest_time[0], resData.playtest_time[1]),
            })
            commit('setValue', {
              key: 'feedbackOpen',
              value: judgeTime(resData.playtest_time[0], resData.playtest_time[1]),
            })
            commit('setValue', {
              key: 'playtestStartTime',
              value: resData.playtest_time[0],
            })
          }

          if (resData.register_time && checkArray(resData.register_time)) {
            commit('setValue', {
              key: 'registerOpen',
              value: judgeTime(resData.register_time[0], resData.register_time[1]),
            })
          }

          switch (resData.region) {
            case 'pt':
              commit('setValue', {
                key: 'nationCode',
                value: '55',
              })
              break
            case 'id':
              commit('setValue', {
                key: 'nationCode',
                value: '62',
              })
              break
          }
          commit('setValue', {
            key: 'indexInit',
            value: true,
          })
          inlineStyle(resData.css) // 加载CSS
          initGA(resData.region, 0)
          addGA('get config', 'success')
        })
        .catch((e: any) => {
          handleError(e)
          errorGA(e)
        })
    )
  },
  setProfile({ commit }: any, obj: Params) {
    const { profile, apkLink } = obj
    commit('setValue', {
      key: 'profile',
      value: profile,
    })
    commit('setValue', {
      key: 'apkLink',
      value: apkLink,
    })
    commit('setValue', {
      key: 'questions',
      value: obj.feedbackQuestions,
    })
    commit('setValue', {
      key: 'imageUpload',
      value: obj.imageUpload,
    })
  },
  setHistory({ commit }: any, history: object[]) {
    commit('setValue', {
      key: 'feedbackHistory',
      value: history,
    })
  },
  setLoginFrom({ commit }: any, from: string) {
    commit('setValue', {
      key: 'loginFrom',
      value: from,
    })
  },
  setUserInfo({ commit }: any, data: any) {
    commit('setValue', {
      key: 'isRegister',
      value: data.registered,
    })
    commit('setValue', {
      key: 'account_ind',
      value: data.is_ind,
    })

    commit('setValue', {
      key: 'isLogin',
      value: true,
    })
    commit('setValue', {
      key: 'userEmail',
      value: data.email,
    })
    commit('setValue', {
      key: 'iosDownloadEnabled',
      value: data.ios_download_enabled,
    })
    commit('setValue', {
      key: 'iosLink',
      value: data.ios_download_url,
    })
    if (data.registered) {
      commit('setValue', {
        key: 'questions',
        value: data.feedback_questions,
      })
      commit('setValue', {
        key: 'profile',
        value: {
          name: data.name,
          email: data.email,
          tel: data.tel,
          lang: state.region,
          channel: data.channel || (state.profile && state.profile.channel) || 1,
        },
      })
      commit('setValue', {
        key: 'apkLink',
        value: data.apk_url,
      })
      commit('setValue', {
        key: 'activationCode',
        value: data.activation_code,
      })
      commit('setValue', {
        key: 'imageUpload',
        value: data.feedback_image_upload,
      })
    }
  },
  // 登陆
  login({ commit }: any, type: string) {
    // type === 1 登录线上服、type === 2登录测试服
    // const callbackUrl: string = 'https://ff-advance.ff.garena.com/' //正式服
    // const callbackUrl: string = 'https://advnew.web.test.freefiremobile.com/' //体验服
    // 后面要换回来
    if (type === 'fb') {
      window.location.href = `https://auth.garena.com/oauth/login?client_id=100067&redirect_uri=${REDIRECT_URL}&response_type=${RESPONSE_TYPE}&all_platforms=1&platform=3`
    }
    if (type == 'google') {
      window.location.href = `https://auth.garena.com/oauth/login?client_id=100067&redirect_uri=${REDIRECT_URL}&response_type=${RESPONSE_TYPE}&all_platforms=1&platform=8`
    }
    addGA('user try to login', 'true')
  },
  // 登出
  logout({ commit }: any) {
    commit('setValue', {
      key: 'isLogin',
      value: false,
    })
    commit('setValue', {
      key: 'userEmail',
      value: '',
    })
    commit('setValue', {
      key: 'code',
      value: '',
    })
    // 设置code为空
    // 清楚登录信息
    deleteCookie('liveAccessToken')
    //
  },
  // handlerError
  handleError({ commit }: any, msg: string = '') {
    Toast['fail'](state.transify[msg] || state.transify['TOAST_NETWORK_BUSY'])
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
